import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Row, Table, UncontrolledDropdown } from "reactstrap";

import ordemServicoService from "services/OrdemServicoService";
import IconButton from "components/IconButton";
import CustomPagination from "components/CustomPagination";
import { statusOrdemServicoList, getStatusOrdemServicoDescription } from "services/OrdemServicoService";
import { ModalIncluir } from "./ModalIncluir";
import { ModalIncluirManual } from "./ModalIncluirManual";
import comboService from "services/ComboService";
import AppContext from "AppContext";
import { PapelEnum } from "services/PerfilService";
import { StatusOrdemServicoEnum, prioridadesOrdemServicoList } from "services/OrdemServicoService";
import PrazoExecucao from "components/PrazoExecucao";
import Prioridade from "components/Prioridade";
import { showLoading } from "components/Loading";
import relatorioService from "services/RelatorioService";
import { erroInesperado } from "services/Utils";
import { toast } from "react-toastify";
import { hideLoading } from "components/Loading";
import { TipoContratoEnum } from "services/ContratoService";
import { confirm } from "components/Confirmation";
import ModalResultadoLiberacao from "./ModalResultadoLiberacao";
import ModalAvisosRelatorio from "components/ModalAvisosRelatorio";

export default function OrdensServico() {
  const { state } = useContext(AppContext)

  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [lotes, setLotes] = useState([])
  const [fiscais, setFiscais] = useState([])
  const [contratos, setContratos] = useState([])
  const [termo, setTermo] = useState(null)
  const [idLote, setIdLote] = useState(null)
  const [idFiscal, setIdFiscal] = useState(null)
  const [prioridade, setPrioridade] = useState(null)
  const [idStatus, setIdStatus] = useState(null)
  const [idContrato, setIdContrato] = useState(state?.contrato?.id)
  const [items, setItems] = useState([])
  const [configModalIncluir, setConfigModalIncluir] = useState()
  const [configModalIncluirManual, setConfigModalIncluirManual] = useState()
  // SDD 038 - ids das OS PENDENTE selecionadas (vale so para a pagina atual)
  const [selecionados, setSelecionados] = useState([])
  const [configModalResultadoLiberacao, setConfigModalResultadoLiberacao] = useState()
  const [relatorioComAvisos, setRelatorioComAvisos] = useState(false)
  const navigate = useNavigate()

  const idTipoPerfil = state?.user?.perfil?.idTipo || 0
  const acoesUsuario = state?.user?.acoes || []
  const contratoObrigatorioNaoSelecionado = idTipoPerfil == PapelEnum.ADMIN && !idContrato

  const usaContratoDoStateParaIncluirManual = idTipoPerfil == PapelEnum.FISCAL || idTipoPerfil == PapelEnum.GESTOR_CONTRATO
  const podeIncluirManual = acoesUsuario.includes('os.criar_manual')
    && (!usaContratoDoStateParaIncluirManual || state?.contrato?.tipoContrato == TipoContratoEnum.NORMAL)

  // SDD 038 - liberacao de execucao em lote (mesma acao da liberacao individual)
  const podeLiberarEmLote = acoesUsuario.includes('os.liberar_execucao')
  const idsPendentesPagina = items.filter(el => el.idStatus == StatusOrdemServicoEnum.PENDENTE).map(el => el.id)
  const todasPendentesSelecionadas = idsPendentesPagina.length > 0 && idsPendentesPagina.every(id => selecionados.includes(id))

  const statusPermitidosExclusao = [
    StatusOrdemServicoEnum.PENDENTE,
    StatusOrdemServicoEnum.AGUARDANDO_SELECAO_EMPRESA_EXECUTORA,
    StatusOrdemServicoEnum.EM_FASE_EXECUCAO,
  ]

  const carregar = async () => {
    setSelecionados([])

    if (contratoObrigatorioNaoSelecionado) {
      setItems([])
      setPaginas(0)
      return
    }

    try {
      showLoading()
      const res = await ordemServicoService.get(termo, idLote, idFiscal, prioridade, idStatus, idContrato, pagina)
      if (res.success) {
        hideLoading()
        setItems(res.data.items)
        setPaginas(res.data.paginas)
      }
    } catch (ex) {
      console.log(ex)
      hideLoading()
      erroInesperado()
    }
  }

  useEffect(() => {
    carregar()
  }, [pagina])

  useEffect(() => {
    if (idTipoPerfil == PapelEnum.ADMIN) {
      comboService.lote().then(res => {
        if (res.success) {
          setLotes(res.data)
        } else {
          setLotes([])
        }
      })
      comboService.fiscal().then(res => {
        if (res.success) {
          setFiscais(res.data)
        } else {
          setFiscais([])
        }
      })
      comboService.contrato().then(res => {
        if (res.success) {
          setContratos(res.data)
        } else {
          setContratos([])
        }
      })
    } else if (idTipoPerfil == PapelEnum.FISCAL) {
      if (state.contrato) {
        setContratos([])
        setIdContrato(state.contrato.id)
      }
    }
  }, [idTipoPerfil, state.contrato])

  const downloadRelatorioOS = async (idOS) => {
    try {
      showLoading()
      const avisos = await relatorioService.gerarPorOS(idContrato, idOS)
      hideLoading()
      if (avisos > 0)
        setRelatorioComAvisos(true)
    } catch (ex) {
      hideLoading()
      if (ex.status == 422) {
        if (ex.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            const result = JSON.parse(reader.result)
            if (result.message)
              toast(result.message)
            else
              erroInesperado()
          };
          reader.readAsText(ex.response.data);
        } else {
          erroInesperado()
        }
      } else {
        erroInesperado()
      }
    }
  }

  const downloadRelatorioFotograficoOS = async (idOS) => {
    try {
      showLoading()
      await relatorioService.gerarFotografico(idOS)
      hideLoading()
    } catch (ex) {
      hideLoading()
      if (ex.status == 422) {
        if (ex.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            const result = JSON.parse(reader.result)
            if (result.message)
              toast(result.message)
            else
              erroInesperado()
          };
          reader.readAsText(ex.response.data);
        } else {
          erroInesperado()
        }
      } else {
        erroInesperado()
      }
    }
  }

  const downloadRelatorioMedicaoOS = async (idOS) => {
    try {
      showLoading()
      await relatorioService.gerarMedicao(idOS)
      hideLoading()
    } catch (ex) {
      hideLoading()
      if (ex.status == 422) {
        if (ex.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            const result = JSON.parse(reader.result)
            if (result.message)
              toast(result.message)
            else
              erroInesperado()
          };
          reader.readAsText(ex.response.data);
        } else {
          erroInesperado()
        }
      } else {
        erroInesperado()
      }
    }
  }

  const handleSubmit = e => {
    e.preventDefault()

    if (contratoObrigatorioNaoSelecionado) {
      toast("Selecione um contrato para buscar as ordens de serviço")
      return
    }

    setPagina(1)
    carregar()
  }

  const podeExcluir = (item) => {
    return statusPermitidosExclusao.includes(item.idStatus)
  }

  const handleSelecionar = (id, marcado) => {
    setSelecionados(atual => marcado
      ? (atual.includes(id) ? atual : [...atual, id])
      : atual.filter(el => el != id))
  }

  const handleSelecionarTodas = (marcado) => {
    setSelecionados(marcado ? idsPendentesPagina : [])
  }

  const handleLiberarExecucaoEmLote = () => {
    const ids = [...selecionados]
    if (ids.length === 0) return

    confirm(`Você deseja liberar a execução de ${ids.length} Ordem(ns) de Serviço?`, async () => {
      try {
        showLoading()
        const res = await ordemServicoService.liberarExecucaoEmLote(ids)
        hideLoading()
        if (res.success) {
          const liberadas = res.data?.liberadas || []
          const falhas = res.data?.falhas || []
          if (falhas.length === 0) {
            toast(`${liberadas.length} Ordem(ns) de Serviço liberada(s) com sucesso!`)
          } else {
            setConfigModalResultadoLiberacao({ liberadas, falhas })
          }
        } else {
          erroInesperado()
        }
      } catch (ex) {
        console.log(ex)
        hideLoading()
        // 400 (validacao) / 403 (RBAC) vem como { statusCode, message }
        const mensagem = ex?.response?.data?.message
        if ([400, 403].includes(ex?.response?.status) && typeof mensagem == 'string' && mensagem) {
          toast(mensagem)
        } else {
          erroInesperado()
        }
      }
      carregar()
    })
  }

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await ordemServicoService.excluir(item.id)
          if (res.success) {
            carregar()
            toast("OS excluída")
          } else {
            toast("Erro ao excluir a OS")
          }
        } catch (ex) {
          toast("Erro ao excluir a OS")
        }
      }
    })
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Ordens de Serviço</h1>
          <div className="d-flex" style={{ gap: 10 }}>
            {podeIncluirManual && (
              <Button color="primary" onClick={() => setConfigModalIncluirManual({})}>Incluir</Button>
            )}
            {acoesUsuario.includes('os.importar') && (
              <Button color="primary" onClick={() => setConfigModalIncluir({})}>Importar</Button>
            )}
          </div>
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col xs={4}>
                  <FormGroup>
                    <Label>Número, Contrato ou Projeto</Label>
                    <Input type="text" placeholder="Número, Contrato ou Projeto" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                {idTipoPerfil == PapelEnum.ADMIN && (
                  <>
                    <Col xs={2}>
                      <FormGroup>
                        <Label>Lote</Label>
                        <select className="form-control" value={idLote || ''} onChange={e => setIdLote(e.target.value)}>
                          <option value="">Todos</option>
                          {lotes.map(el => (
                            <option key={el.id} value={el.id}>{el.nome}</option>
                          ))}
                        </select>
                      </FormGroup>
                    </Col>
                    <Col xs={4}>
                      <FormGroup>
                        <Label>Fiscal</Label>
                        <select className="form-control" value={idFiscal || ''} onChange={e => setIdFiscal(e.target.value)}>
                          <option value="">Todos</option>
                          {fiscais.map(el => (
                            <option key={el.id} value={el.id}>{el.nome}</option>
                          ))}
                        </select>
                      </FormGroup>
                    </Col>
                    <Col xs={3}>
                      <FormGroup>
                        <Label>Contratos</Label>
                        <select
                          className="form-control"
                          value={idContrato || ''}
                          onChange={(ev) => setIdContrato(ev.target.value != '' ? +ev.target.value : undefined)}
                          required
                        >
                          <option value="">Selecione o contrato</option>
                          {contratos.map(el => (
                            <option key={el.id} value={el.id}>{el.numero}</option>
                          ))}
                        </select>
                        {contratoObrigatorioNaoSelecionado && (
                          <small className="text-muted">
                            Selecione um contrato para habilitar a busca e visualizar as ordens de serviço.
                          </small>
                        )}
                      </FormGroup>
                    </Col>
                  </>
                )}
                <Col xs={3}>
                  <FormGroup>
                    <Label>Status</Label>
                    <select className="form-control" value={idStatus || ''} onChange={e => setIdStatus(e.target.value)}>
                      <option value="">Todos</option>
                      {statusOrdemServicoList.map(status => (
                        <option key={status} value={status}>{getStatusOrdemServicoDescription(status)}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col xs={3}>
                  <FormGroup>
                    <Label>Prioridade</Label>
                    <select className="form-control" value={prioridade || ''} onChange={e => setPrioridade(e.target.value)}>
                      <option value="">Todos</option>
                      {prioridadesOrdemServicoList.map(p => <option key={p} value={p}>{p}</option>)}
                      <option value="SEM">Sem prioridade</option>
                    </select>
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary" disabled={contratoObrigatorioNaoSelecionado}>Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        {podeLiberarEmLote && (
          <div className="d-flex justify-content-end mb-3">
            <Button color="primary" disabled={selecionados.length === 0} onClick={handleLiberarExecucaoEmLote}>
              Liberar execução ({selecionados.length})
            </Button>
          </div>
        )}

        <Card className="shadow">
          <Table className="align-items-center table-flush">
            <thead className="thead-light">
              <tr>
                {podeLiberarEmLote && (
                  <th scope="col" style={{ width: 40 }}>
                    <input
                      type="checkbox"
                      title="Selecionar todas as OS pendentes da página"
                      checked={todasPendentesSelecionadas}
                      disabled={idsPendentesPagina.length === 0}
                      onChange={e => handleSelecionarTodas(e.target.checked)}
                    />
                  </th>
                )}
                <th scope="col">OS</th>
                <th scope="col">Prazo</th>
                <th scope="col">Emp. Executora</th>
                <th scope="col">Prioridade</th>
                <th scope="col">Status</th>
                <th scope="col">&nbsp;</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr>
                  <td colSpan={podeLiberarEmLote ? 8 : 7} className="text-center">
                    {contratoObrigatorioNaoSelecionado
                      ? 'Selecione um contrato para visualizar as ordens de serviço.'
                      : 'Nenhum registro'}
                  </td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  {podeLiberarEmLote && (
                    <td>
                      {el.idStatus == StatusOrdemServicoEnum.PENDENTE && (
                        <input
                          type="checkbox"
                          checked={selecionados.includes(el.id)}
                          onChange={e => handleSelecionar(el.id, e.target.checked)}
                        />
                      )}
                    </td>
                  )}
                  <td>{el.numeroFmt}</td>
                  <td>
                    <PrazoExecucao prazoExecucaoFmt={el.prazoExecucaoFmt} situacaoPrazo={el.situacaoPrazo} />
                  </td>
                  <td>{el.razaoSocialEmpresaExecutora}</td>
                  <td>
                    <Prioridade prioridade={el.prioridade} concluida={[StatusOrdemServicoEnum.CONCLUIDA, StatusOrdemServicoEnum.CANCELADA].includes(el.idStatus)} />
                  </td>
                  <td>{el.idStatusFmt}</td>
                  <td>
                    <strong>Data:</strong> {el.dataFmt}<br />
                    <strong>Projeto:</strong> {el.numeroProjeto}<br />
                    <strong>Contrato:</strong> {el.numeroContrato}<br />
                    <strong>Lote:</strong> {el.lote}<br />
                    <strong>Fiscal:</strong> {el.fiscal}<br />
                    <strong>Previsão Início:</strong> <PrazoExecucao prazoExecucaoFmt={el.dataPrevisaoInicioFmt} situacaoPrazo={el.situacaoPrevisaoInicio} /><br />
                    <strong>Total Previsto:</strong> R$ {el.totalPrevistoFmt}<br />
                    {el.tipoContrato === TipoContratoEnum.SEMAFORICO && (
                      <>
                      <strong>Cruzamento:</strong> {el.numeroCruzamento}<br />
                      </>
                    )}
                  </td>
                  <td className="text-right">
                    <UncontrolledDropdown>
                      <DropdownToggle data-toggle="dropdown" tag="span">
                        <IconButton alt="Ações" iconClass="bi-three-dots-vertical" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem onClick={() => navigate("/admin/ordens_servico/" + el.id)}>
                          Editar
                        </DropdownItem>
                        {podeExcluir(el) && (
                          <DropdownItem onClick={() => handleDelete(el)}>
                            Excluir
                          </DropdownItem>
                        )}
                        <DropdownItem onClick={() => downloadRelatorioOS(el.id)}>
                          Baixar relatório
                        </DropdownItem>
                        <DropdownItem onClick={() => downloadRelatorioFotograficoOS(el.id)}>
                          Baixar relatório fotográfico
                        </DropdownItem>
                        <DropdownItem onClick={() => downloadRelatorioMedicaoOS(el.id)}>
                          Baixar relatório de medição
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>

        <ModalIncluir
          config={configModalIncluir}
          onClosed={() => setConfigModalIncluir()}
          onChange={() => {
            carregar()
          }}
        />

        <ModalIncluirManual
          config={configModalIncluirManual}
          onClosed={() => setConfigModalIncluirManual()}
          onChange={() => {
            carregar()
          }}
        />

        <ModalResultadoLiberacao
          config={configModalResultadoLiberacao}
          onClosed={() => setConfigModalResultadoLiberacao()}
        />

        <ModalAvisosRelatorio isOpen={relatorioComAvisos} onClosed={() => setRelatorioComAvisos(false)} />

      </Container>
    </>
  )
}